import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import PopupWrapper from '../common/PopupWrapper';
import Loader from '../../../../../common/Loader';
import DescriptionSection from '../common/DescriptionSection';
import InsuranceForm from '../../../../../forms/InsuranceForm';

import { INSURANCE_FLOW_TYPE } from '../../../../../../constants/insurance-flow-type';

import useFetchToDoTaskInsurancesData from '../../hooks/useFetchToDoTaskInsurancesData';

import styles from './index.styl';

const FLOW_TYPE = INSURANCE_FLOW_TYPE.TO_DO;

const InsuranceToDoTaskInProgressPopup = ({
  task,
  taskId,
  onClose,
  userId,
}) => {
  const { formatMessage } = useIntl();

  const {
    todoTask,
    taskAssigneeId,
    hasAdditionalPatientInsurances,
    patientInsurance,
  } = task || {};

  const { allowToCompleteWithoutFileUpload, description, links } =
    todoTask || {};

  const { isInsuranceRelatedDataFetching } = useFetchToDoTaskInsurancesData({
    userId,
    hasAdditionalPatientInsurances,
    todoTaskAssignmentId: taskId,
    isCompleted: false,
  });

  return (
    <Fragment>
      <PopupWrapper
        handleClose={onClose}
        taskId={taskId}
        task={task}
        title={formatMessage({ id: 'task.upcoming' })}
      >
        <div className={styles.content}>
          <div className={styles.descriptionSection}>
            <DescriptionSection description={description} links={links} />
          </div>

          {isInsuranceRelatedDataFetching ? (
            <Loader />
          ) : (
            <InsuranceForm
              cancel={onClose}
              flowType={FLOW_TYPE}
              insuranceData={patientInsurance}
              taskAssignmentId={taskId}
              userId={taskAssigneeId}
              withSelfPayEnding
              allowToCompleteWithoutFileUpload={
                allowToCompleteWithoutFileUpload
              }
            />
          )}
        </div>
      </PopupWrapper>
    </Fragment>
  );
};

InsuranceToDoTaskInProgressPopup.propTypes = {
  onClose: PropTypes.func,
  task: PropTypes.object,
  taskId: PropTypes.number,
  userId: PropTypes.number,
};

export default InsuranceToDoTaskInProgressPopup;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/InsuranceToDoTaskPopup/components/InsuranceToDoTaskInProgressPopup/index.jsx